import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ALL_ORGANIZATIONS = gql`
  query AllOrganizations($input: AllOrganizationsInput) {
    allOrganizations(input: $input) {
      items {
        _id
        name
        type
        tier
        description
        picture
        website
        isActive
        memberCount
        maxUsers
        effectiveMaxUsers
        seatUsage {
          used
          limit
          percentage
          status
        }
        sso {
          enabled
          enforced
        }
        createdAt
        updatedAt
      }
      total
      hasMore
    }
  }
`;

export const ORGANIZATION_DETAIL_ADMIN = gql`
  query OrganizationDetailAdmin($organizationId: ID!) {
    organizationDetailAdmin(organizationId: $organizationId) {
      organization {
        _id
        name
        type
        tier
        description
        picture
        website
        isActive
        memberCount
        maxUsers
        effectiveMaxUsers
        seatUsage {
          used
          limit
          percentage
          status
        }
        createdAt
        updatedAt
      }
      memberCount
      rosterCount
      activeMarketplaceItemCount
      totalOrders
      totalKoinsEarned
      totalKoinsSpent
      activeChallengeCount
      activeEventCount
    }
  }
`;

export const SEARCH_USERS = gql`
  query SearchUsers($search: String, $limit: Int) {
    users(search: $search, limit: $limit) {
      edges {
        node {
          _id
          firstName
          lastName
          email
          role
          accountStatus
          avatar
        }
      }
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const ADMIN_CREATE_ORGANIZATION = gql`
  mutation AdminCreateOrganization($input: AdminCreateOrganizationInput!) {
    adminCreateOrganization(input: $input) {
      organization {
        _id
        name
        type
        tier
        description
        picture
        website
        isActive
        memberCount
        maxUsers
        effectiveMaxUsers
        createdAt
        updatedAt
      }
      assignedAdmin {
        _id
        firstName
        lastName
        email
        role
        accountStatus
        avatar
      }
      isNewUser
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      _id
      name
      type
      description
      picture
      website
      isActive
      memberCount
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
    updateOrganization(id: $id, input: $input) {
      _id
      name
      type
      description
      picture
      website
      isActive
      memberCount
      createdAt
      updatedAt
    }
  }
`;

export const SUSPEND_ORGANIZATION = gql`
  mutation SuspendOrganization($input: SuspendOrganizationInput!) {
    suspendOrganization(input: $input) {
      _id
      name
      type
      isActive
      updatedAt
    }
  }
`;

export const REACTIVATE_ORGANIZATION = gql`
  mutation ReactivateOrganization($organizationId: ID!) {
    reactivateOrganization(organizationId: $organizationId) {
      _id
      name
      type
      isActive
      updatedAt
    }
  }
`;

// ─── Tier Management ─────────────────────────────────────────────────────────

export const UPDATE_ORGANIZATION_TIER = gql`
  mutation UpdateOrganizationTier(
    $organizationId: ID!
    $input: UpdateOrganizationTierInput!
  ) {
    updateOrganizationTier(
      organizationId: $organizationId
      input: $input
    ) {
      organization {
        _id
        name
        type
        tier
        maxUsers
        effectiveMaxUsers
        seatUsage {
          used
          limit
          percentage
          status
        }
        memberCount
        updatedAt
      }
      seatUsage {
        used
        limit
        percentage
        status
      }
      pendingEnrollmentCount
    }
  }
`;

export const ENROLL_PENDING_ROSTER_USERS = gql`
  mutation EnrollPendingRosterUsers($organizationId: ID!) {
    enrollPendingRosterUsers(organizationId: $organizationId) {
      enrolledCount
      skippedCount
      totalPending
    }
  }
`;
